import { render } from "./MainSideMenu.vue?vue&type=template&id=0566c914"
import script from "./MainSideMenu.vue?vue&type=script&lang=js"
export * from "./MainSideMenu.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__